// extracted by mini-css-extract-plugin
export default {"fs6":"Categories_fs6__5LTH-","py8":"Categories_py8__FQrtb","textTruncate":"Categories_textTruncate__CowBR","cardProduct":"Categories_cardProduct__8g9A4"};